<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orderStateOptions: [], // 订单状态
        financeStsOptions: [], // 核销状态
        lineProperOptions: [], // 线路属性
        stateTypeOptions: [], // 订单类型
        orgIdOptions: [],
        form: [
          { // 账单号码
            label: '账单号码',
            value: 'billNumber',
            type: 'input',
            default: this.$route.query.billNumber,
            placeholder: '请输入账单号码',
          },
          { // 客户名称
            label: '客户名称',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 对账名称
            label: '对账名称',
            value: 'checkName',
            type: 'input',
            placeholder: '请输入对账名称',
          },
          { // 发车时间
            label: '发车时间',
            value: 'departTime',
            type: 'date',
            placeholder: '请输入发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 订单状态
            label: '订单状态',
            value: 'orderState',
            type: 'select',
            default: -1,
            placeholder: '请选择订单状态',
          },
          { // 客户回单号
            label: '客户回单号',
            value: 'customOrderIds',
            type: 'input',
            placeholder: '请输入客户回单号',
          },
          { // 账单生成
            label: '账单生成',
            value: 'isBillNumber',
            type: 'select',
            default: -1,
            placeholder: '请选择账单生成',
            options: [
              {
                label: '全部',
                value: -1,
              },
              {
                label: '未生成',
                value: 1,
              },
              {
                label: '已生成',
                value: 2,
              },
            ],
          },
          { // 发票号码
            label: '发票号码',
            value: 'receiptNumber',
            type: 'input',
            placeholder: '请输入发票号码',
          },
          { // 核销状态
            label: '核销状态',
            value: 'financeSts',
            type: 'select',
            default: -1,
            placeholder: '请选择核销状态',
          },
          { // 线路属性
            label: '线路属性',
            value: 'lineProper',
            type: 'select',
            default: -1,
            placeholder: '请选择线路属性',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
          },
          { // 客户单号
            label: '客户单号',
            value: 'customNumber',
            type: 'input',
            placeholder: '请输入客户单号',
          },
          { // 订单类型
            label: '订单类型',
            value: 'stateType',
            type: 'select',
            default: -1,
            placeholder: '请选择订单类型',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.billNumber': function (newVal) {
      if (this.$route.path === '/manage/getPay/customer/order' && newVal) {
        this.$refs.searchBox.setVal('billNumber', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.departTime) {
        searchBoxData.departStartTime = this.formatDate(searchBoxData.departTime[0]);
        searchBoxData.departEndTime = this.formatDate(searchBoxData.departTime[1]);
        delete searchBoxData.departTime;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ORDER_STATE_TYPE,ORDER_TYPE,ORDER_STATE,FINANCE_STS',
    });
    this.searchBoxData.stateTypeOptions = [ // 订单类型
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.lineProperOptions = [ // 线路属性
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.orderStateOptions = [ // 订单状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
    this.searchBoxData.financeStsOptions = [ // 核销状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[3],
    ];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
